var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.events),function(event){return _c('event-list-item',{key:JSON.stringify(event),attrs:{"event":event,"hide-delete":_vm.hideDelete},on:{"delete":_vm.onDelete}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }